import { endOfMonth, endOfQuarter, startOfMonth, startOfQuarter } from "date-fns";

import ForecastViewMode from "../enum/ForecastViewMode";

export const startOf: Record<ForecastViewMode, (date: Date | number) => Date> = {
  [ForecastViewMode.MONTH]: startOfMonth,
  [ForecastViewMode.QUARTER]: startOfQuarter,
};

export const endOf: Record<ForecastViewMode, (date: Date | number) => Date> = {
  [ForecastViewMode.MONTH]: endOfMonth,
  [ForecastViewMode.QUARTER]: endOfQuarter,
};
